// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"CtaWrapper_ctaWrapper__D1Dxh","full":"CtaWrapper_full__cS35Z","column":"CtaWrapper_column__TyRm+"};